import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { useHelpModalState } from 'react-commons';
import { Props } from '../LocationAmount';
import { useGlobalState } from '../../../state/persistence';
import { useSetFlow, useStyles } from '../../Shared';

const useLocationAmount = ({ flow, nextUrl }: Props) => {
  useSetFlow(flow);
  const { t } = useTranslation('location_amount');
  const history = useHistory();
  const { dispatchQuestion } = useGlobalState();
  const { toggleHelpModal } = useHelpModalState();

  const onOneClick = () => {
    dispatchQuestion('locationAmount', '1');

    if (nextUrl) {
      history.push(Array.isArray(nextUrl) ? nextUrl[0] : nextUrl);
    }
  };

  const onMoreClick = () => {
    dispatchQuestion('locationAmount', '1+');

    if (nextUrl) {
      window.location.href = Array.isArray(nextUrl) ? nextUrl[1]! : nextUrl;
    }
  };

  return {
    classes: useStyles(),
    t,
    onOneClick,
    onMoreClick,
    toggleHelpModal,
  };
};

export default useLocationAmount;
